import { render, staticRenderFns } from "./base-collection.vue?vue&type=template&id=75cb260a&scoped=true&"
import script from "./base-collection.vue?vue&type=script&lang=js&"
export * from "./base-collection.vue?vue&type=script&lang=js&"
import style0 from "./base-collection.vue?vue&type=style&index=0&id=75cb260a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cb260a",
  null
  
)

export default component.exports